import { Link } from 'react-router-dom';
import type { ShowItem } from '@/mocks/shows';

export default function ShowCard({ item }: { item: ShowItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      data-product-shop
      className="group block cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1 bg-primary-950/80 text-background-50 text-xs font-label font-bold px-2 py-0.5 rounded-full">
          <i className="ri-star-fill text-accent-400 text-[11px]"></i>
          {item.rating}
        </div>
        <span className="absolute top-2 right-2 bg-background-50/90 text-foreground-800 text-[11px] font-label font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
          {item.type === 'tv' ? '电视剧' : '电影'}
        </span>
      </div>
      <h3 className="mt-2.5 font-heading text-sm md:text-base font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
        {item.title}
      </h3>
      <p className="mt-1 text-xs text-foreground-500 font-label">
        {item.year} · {item.region} · {item.genres[0]}
      </p>
    </Link>
  );
}